import { FallbackHeuristics } from "../../ai/fallbacks";
import { KanbanTriageRequest, KanbanTriageDecision } from '../../ai/jev-types';
import { WorkItemPriority } from './work-item-contracts';

export class KanbanTriageService {
  constructor(private readonly endpoint: string = process.env.JEV_ENDPOINT || 'http://127.0.0.1:8088') {}

  async triageCard(req: KanbanTriageRequest): Promise<KanbanTriageDecision> {
    const started = Date.now();
    const fallback = this.heuristicFallback(req, started);

    if (process.env.JEV_ENABLED !== 'true') {
      return fallback;
    }

    try {
      const res = await fetch(`${this.endpoint}/decision/KANBAN_CARD_TRIAGE`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Connection': 'keep-alive' },
        body: JSON.stringify(req),
        signal: AbortSignal.timeout(100),
      });

      if (!res.ok) return fallback;

      const data = (await res.json()) as KanbanTriageDecision;
      return {
        ...data,
        source: 'jev',
        latencyMs: Date.now() - started,
      };
    } catch {
      return fallback;
    }
  }

  private heuristicFallback(req: KanbanTriageRequest, started: number): KanbanTriageDecision {
    const hasUrgentTag = req.labels.some((l) => ['p0', 'incident', 'critical', 'blocker'].includes(l.toLowerCase()));
    const isUrgent = (((req.priority as any) as any) as string) === 'urgent' || hasUrgentTag;

    return {
      source: 'heuristic',
      timestampMs: started,
      latencyMs: Date.now() - started,
      recommendedPriority: isUrgent ? ('urgent' as WorkItemPriority) : (req.priority as string),
      suggestedAssigneeGroup: isUrgent ? 'incident-response' : 'general',
      autoEscalateSla: isUrgent,
      confidence: 0.85,
      triageReason: isUrgent ? 'heuristic_detected_blocker_label' : 'heuristic_baseline',
    };
  }
}
